module.exports = require("eslint");